var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"collapse-toggle",class:{'collapsed': _vm.collapsed},attrs:{"data-toggle":"collapse","href":`#${_vm.target}`}},[_c('icon',{staticClass:"icon",attrs:{"icon":"plus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }